import { render, staticRenderFns } from "./tweet.vue?vue&type=template&id=f02a810a&scoped=true&"
import script from "./tweet.vue?vue&type=script&lang=js&"
export * from "./tweet.vue?vue&type=script&lang=js&"
import style0 from "./tweet.vue?vue&type=style&index=0&id=f02a810a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02a810a",
  null
  
)

export default component.exports